module.exports = __webpack_public_path__ + "static/img/GB.133ae7cb.png";